import React, { Suspense, useRef } from 'react'
import { Canvas } from "@react-three/fiber"
import { OrbitControls, Stage, useGLTF } from '@react-three/drei'
import { Model } from './Model'

export default function ThreeDModel() {
    const ref = useRef()

    return (
        <Canvas shadows dpr={[1, 2]} camera={{ fov: 50 }}>
        <Suspense fallback={null}>
          <Stage controls={ref} preset="soft" intensity={2}  environment="warehouse">
          false
            <Model />
          false
          </Stage>
        </Suspense>
        <OrbitControls ref={ref} />
      </Canvas>
  
    );
}
